import { AVRProducts, ProductRoutes } from './enums';

export const ProductMap = [
  {
    name: AVRProducts.CREDIT,
    route: ProductRoutes.CREDIT,
  },
  {
    name: AVRProducts.TRADE,
    route: ProductRoutes.TRADE,
  },
  {
    name: AVRProducts.ACQUIRE,
    route: ProductRoutes.ACQUIRE,
  },
  {
    name: AVRProducts.INSURANCE,
    route: ProductRoutes.INSURANCE,
  },
  {
    name: AVRProducts.REVIEWS,
    route: ProductRoutes.REVIEWS,
  },
  {
    name: AVRProducts.SPOTLIGHT,
    route: ProductRoutes.SPOTLIGHT,
  },
  {
    name: AVRProducts.TEST_DRIVE,
    route: ProductRoutes.TEST_DRIVE,
  },
  {
    name: AVRProducts.ECOMV2,
    route: ProductRoutes.ECOMV2,
  },
  {
    name: AVRProducts.SPIN,
    route: ProductRoutes.SPIN,
  },
  {
    name: AVRProducts.BUILD_AND_PRICE,
    route: ProductRoutes.BUILD_AND_PRICE,
  },
];

export default ProductMap;
